import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { WordsActions, WordsStoreStates } from '.'
import { CSVLink, WordsButton, WordsDemoButton } from './styles'

type OwnProps = {}
type WordsProps = OwnProps & WordsStoreStates & WordsActions

const Words = (props: WordsProps) => {
  const { listId } = useParams<{ listId: string }>()
  const { readingWords, setDefaultList, setDemoList, updateList } = props
  const { words, update } = readingWords

  const [isOpenDefaultDialog, setIsOpenDefaultDialog] = useState(false)
  const [isOpenDemoDialog, setIsOpenDemoDialog] = useState(false)

  const onInput = (file: File | null | undefined) => {
    if (!file) return

    const { list } = words || {}
    if (!list) return

    updateList({ list, file })
  }

  const closeDialog = () => {
    setIsOpenDefaultDialog(false)
    setIsOpenDemoDialog(false)
  }

  useEffect(() => {
    // 発話ワードリストの読み込み
    if (listId) props.loadWords(listId)
  }, [])

  if (!words) return <></>

  const { loading, isSucceeded, items, list } = words
  const csvData = items.map((item) => [item.id, item.text, item.weight])

  if (loading) return <></>

  if (!isSucceeded || !list) return <Typography color="secondary">エラーが発生しました</Typography>

  return (
    <Container>
      <CssBaseline />
      <Paper sx={{ mb: 2 }}>
        <Toolbar>
          <Grid size="grow">
            <Typography variant="h6" style={{ flex: '1 1 100%' }}>
              {list.title}
              <WordsButton
                size="small"
                component="label"
                disabled={list.isDefault}
                onClick={() => !list.isDefault && setIsOpenDefaultDialog(true)}>
                デフォルト
              </WordsButton>
              <WordsDemoButton
                size="small"
                component="label"
                disabled={list.canPredict}
                onClick={() => !list.canPredict && setIsOpenDemoDialog(true)}>
                デモ
              </WordsDemoButton>
            </Typography>
          </Grid>
          {update.isSucceeded && (
            <Typography color="primary" variant="subtitle1">
              リストを更新しました
            </Typography>
          )}
          {update.isSucceeded === false && (
            <Typography color="secondary" variant="subtitle1">
              エラーが発生しました
            </Typography>
          )}
          <Tooltip title="テキストファイルから発話ワードを更新します" disableInteractive>
            <Button variant="contained" component="label" color="secondary" disabled={update.processing} sx={{ mx: 1 }}>
              {update.processing ? <CircularProgress size={20} /> : '内容を書き換える'}
              <input
                type="file"
                accept=".csv"
                style={{ display: 'none' }}
                onChange={(e) => onInput(e.target.files?.item(0))}
              />
            </Button>
          </Tooltip>
        </Toolbar>
        <TableContainer>
          <Table size="small" aria-label="word list">
            <TableHead>
              <TableRow>
                <TableCell>言葉</TableCell>
                <TableCell align="right">重み&nbsp;(0.0~1.0)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items
                .filter((item) => item.isEnabled)
                .map((row) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      {row.text}
                    </TableCell>
                    <TableCell align="right">{row.weight}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Toolbar>
          <Grid container size="grow">
            <Grid size="grow" />
            <Grid>
              <Button variant="contained" component="label" color="primary">
                <CSVLink filename={`${list.title}.csv`} target="_blank" data={csvData} />
                CSV エクスポート
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </Paper>
      <Dialog
        open={isOpenDefaultDialog || isOpenDemoDialog}
        onClose={() => closeDialog()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'確認'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            このリストを
            {isOpenDefaultDialog ? 'デフォルトに設定しますか？' : 'デモで使用しますか？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()} color="primary">
            キャンセル
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              closeDialog()
              isOpenDefaultDialog ? setDefaultList(list) : setDemoList(list)
            }}>
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}

export default Words
